var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filters-list" }, [
    _c("form", { staticClass: "form", attrs: { action: "/search/" } }, [
      _c(
        "label",
        { staticClass: "form__label w-search", attrs: { for: "search-input" } },
        [
          _c("input", {
            staticClass: "w-search__submit",
            attrs: { name: "q", value: "" }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.q,
                expression: "q"
              }
            ],
            staticClass: "form__input w-search__input",
            attrs: {
              type: "text",
              id: "search-input",
              name: "q",
              placeholder: _vm.text.search
            },
            domProps: { value: _vm.q },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.q = $event.target.value
              }
            }
          })
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "component__tab-filters tab-filters" }, [
      _c(
        "ul",
        { staticClass: "tab-filters__list ul--clear" },
        _vm._l(_vm.data, function(item, index) {
          return _c("li", { key: index, staticClass: "tab-filters__item" }, [
            _c(
              "a",
              {
                staticClass: "tab-filters__link",
                class: { "tab-filters__link--active": _vm.type === item.name },
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changeTab(item.name)
                  }
                }
              },
              [_vm._v(_vm._s(item.name))]
            )
          ])
        }),
        0
      )
    ]),
    _vm._v(" "),
    _vm.filteredList && _vm.filteredList.length
      ? _c(
          "ul",
          { staticClass: "filters-list__list" },
          _vm._l(_vm.filteredList, function(item, index) {
            return _c("li", {
              key: index,
              domProps: { innerHTML: _vm._s(item) }
            })
          }),
          0
        )
      : _c("p", {
          staticClass: "u-top-margin--30",
          domProps: { innerHTML: _vm._s(_vm.text.unfound) }
        })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9be53096", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9be53096","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/components/filters-list/filters-list.vue
// module id = 136
// module chunks = 0